import { liteClient as algoliasearch } from 'algoliasearch/lite';
import insightsClient from 'search-insights';
import config from "../../../lib/frontend-config";

const appId = config.get('ALGOLIA_APP_ID'); // 'EYD0JVVPH3';
const apiKey = config.get('ALGOLIA_SEARCH_API_KEY'); // '495d78f0e53ce8b0bf5962001c213661';
const baseIndexName = config.get('ALGOLIA_BASE_INDEX_NAME'); // 'my-index-test1';

if (!appId || !apiKey) {
  throw new Error('appId or apiKey not set!');
}

//
const searchClient = algoliasearch(appId, apiKey);

//
insightsClient('init', { appId, apiKey });

//
const locale = config.get('LOCALE') || '';

// set the index names for the cms and ocs based on the locale
const CMS_INDEX_NAME = `${baseIndexName}_cms_${locale.replace('-', '_')}`;
const OCS_INDEX_NAME = `${baseIndexName}_ocs_${locale.replace('-', '_')}`;

export { searchClient, CMS_INDEX_NAME, OCS_INDEX_NAME };
